import { useState, useCallback, useMemo } from "react";
import { FaArrowRight } from "react-icons/fa6";
import {
  Button,
  InputField,
  AddressInputField,
  DropDownInput,
} from "@/components";
import { SheetClose } from "@/components/ui/sheet";
import { callRequest } from "../../app/slices";
import { useDispatch } from "react-redux";
import { useAlert } from "@/";
const RequestCallForm = ({
  handleCloseSidebar,
  setSheetOpen = { setSheetOpen },
}) => {
  const dispatch = useDispatch();
  const { alert, AlertDialog } = useAlert();
  const [formData, setFormData] = useState({
    mobileNo: "",
    queryRelatedTo: "",
    preferredDate: "",
    preferredTime: "",
    message: "",
  });

  // Memoized Dropdown Options (Prevents Unnecessary Re-Creation)
  const queryOptions = useMemo(
    () => [
        {
        label: "Pickup",
        value: "pickupDelivery",
      },
      {
        label: "Pre Delivery",
        value: "shipmentNdrRto",
      },
      {
        label: "Claim",
        value: "weightDispute",
      },
      {
        label: "Finance",
        value: "finance",
      },
      {
        label: "KYC",
        value: "kycBankVerification",
      },
      {
        label: "Technical Support",
        value: "technicalSupport",
      },
      {
        label: "Billing & Taxation",
        value: "billingTaxation",
      },
      {
        label: "Post Delivery",
        value: "claims",
      },
      {
        label: "Other",
        value: "other",
      },
    ],
    []
  );

  // Generic Input Handler to Update State Efficiently
  const handleChange = useCallback((key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      let callbackTime = null;
      if (formData.preferredDate && formData.preferredTime) {
        const localDateTimeStr = `${formData.preferredDate}T${formData.preferredTime}`;
        const dateObj = new Date(localDateTimeStr);
        if (!isNaN(dateObj.getTime())) {
          callbackTime = dateObj.toISOString();
        }
      }

      // Prepare request data
      const requestData = {
        phone: formData.mobileNo,
        query: formData.queryRelatedTo,
        message: formData.message,
        callbackTime,
      };
      console.log("Request Data:", requestData);

      // Dispatch the callRequest thunk
      const response = await dispatch(callRequest(requestData));

      if (callRequest.fulfilled.match(response)) {
        console.log("Call Request created successfully:", response.payload);
        await alert(
          "Your call request has been created successfully. Our team will contact you shortly."
        );
      } else if (callRequest.rejected.match(response)) {
        console.error("Call Request creation failed:", response.payload);
        await alert(response.payload || "Call Request creation failed.");
        return;
      }

      // Reset form
      setFormData({
        mobileNo: "",
        queryRelatedTo: "",
        preferredDate: "",
        preferredTime: "",
        message: "",
      });

      setSheetOpen(false); // Close the sheet after successful submission
    } catch (error) {
      console.error("Call Request creation failed:", error);
      await alert(
        error?.message || "Failed to create Call Request. Please try again."
      );
    }
  };

  const minDateToday = useMemo(() => new Date().toISOString().split("T")[0], []);

  return (
    <div className="flex flex-col gap-3">
      {/* Mobile Number Input */}
      <InputField
        label="Mobile No."
        type="number"
        placeholder="Enter your mobile number"
        value={formData.mobileNo}
        onChange={(val) => handleChange("mobileNo", val)}
      />
      {/* Query Type Selection */}
      <DropDownInput
        label="Query Related to"
        placeholder="Select query related to"
        options={queryOptions}
        value={formData.queryRelatedTo}
        onChange={(val) => handleChange("queryRelatedTo", val)}
      />
      {/* Date & Time Selection for Callback */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <InputField
          label="Preferred Date"
          type="date"
          min={minDateToday}
          value={formData.preferredDate}
          onChange={(val) => handleChange("preferredDate", val)}
        />
        <InputField
          label="Preferred Time"
          type="time"
          value={formData.preferredTime}
          onChange={(val) => handleChange("preferredTime", val)}
        />
      </div>
      {/* Message Input Field */}
      <AddressInputField
        label="Add Your Message"
        placeholder="Enter your message"
        value={formData.message}
        onChange={(val) => handleChange("message", val)}
      />
      {/* Action Buttons */}
      <div className="flex justify-end gap-2">
        <SheetClose asChild>
          <Button
            variant="outline"
            size="sm"
            onClick={handleCloseSidebar}
            className="mt-4"
          >
            Close
          </Button>
        </SheetClose>

        <Button
          type="submit"
          icon={FaArrowRight}
          variant="default"
          onClick={handleSubmit}
          size="sm"
          className="mt-4"
        >
          Create
        </Button>
      </div>
      <AlertDialog />
    </div>
  );
};

export default RequestCallForm;
